<template>
  <div class="min-h-full">
    <div
      v-if="sportcomplex && accommodatie"
      class="flex flex-col m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 bg-gray-100 p-3"
    >
      <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
        Accommodaties in sportcomplex
      </p>

      <Map :latlon="accommodatie.latlon" />

      <div
        class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 grid-flow-row gap-4"
      >
        <div
          v-for="acc in sportcomplex.accommodaties"
          :key="acc.id"
          @click="openAccomm(acc.id)"
          class="bg-gray-200 hover:bg-opacity-25 font-opensans rounded-lg shadow-lg hover:shadow-xl cursor-pointer"
        >
          <div
            class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
          >
            {{ acc.naam }}
          </div>

          <p class="font-opensans mt-4 mx-4 text-sm truncate capitalize">
            {{ acc.straat }}
          </p>
          <p class="font-opensans mx-4 text-sm truncate capitalize">
            {{ acc.plaats.naam }}
          </p>
          <p
            class="font-opensans mx-4 text-sm truncate"
            v-if="acc.id === accommodatie.id"
          >
            Huidige accommodatie
          </p>

          <p class="font-opensans m-4 text-sm text-gray-500 truncate">
            <span v-for="sport in acc.sporten" v-bind:key="sport"
              >{{ sport }}
            </span>
          </p>
        </div>
      </div>
    </div>
    <div
      v-else
      class="flex m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 p-3"
    >
      <div class="m-auto">
        <img src="../../../assets/logo.svg" class="w-64 pl-8 mt-32" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Map from "./Map";
export default {
  name: "SportcomplexHome",
  components: { Map },
  created: function() {
    this.loadSportcomplexByAccommodatieId(this.$route.params.id);
  },
  computed: mapState({
    accommodatie: state => state.backend_data.current_accommodatie,
    sportcomplex: state => state.backend_data.current_sportcomplex
  }),
  methods: {
    ...mapActions(["loadSportcomplexByAccommodatieId"]),
    openAccomm: function(accomm_id) {
      this.$emit("showAccommComp");
      this.$router.push({
        name: "Accommodatie",
        params: { id: accomm_id }
      });
    }
  }
};
</script>
